const ROOT_FQDN = process.env.VUE_APP_ROOT_FQDN

export {
    ROOT_FQDN
};